import qs from 'qs';

const baseUrl = process.env.SENDWISE_PUBLIC_API_URL;

function fetchRequest(url) {
  if (!baseUrl) {
    throw new Error('SENDWISE_PUBLIC_API_URL is not defined');
  }

  // workaround for supporting finally method
  return Promise.resolve(fetch(`${baseUrl}${url}`)).then((res) => {
    if (res.ok) {
      return res.json();
    }

    throw res;
  });
}

export function getTrackingInfo(embeddedWidgetId, orderId, zipCode) {
  const query = qs.stringify({
    embeddedWidgetId,
    orderId,
    zipCode,
  });
  return fetchRequest(`/tracking?${query}`);
}

export function getOrderDataByTrackingPage(trackingPageId, orderId, zipCode, language) {
  const query = qs.stringify({
    trackingPageId,
    orderId,
    zipCode,
    language,
  });
  return fetchRequest(`/tracking?${query}`);
}

export function getDummyTrackingData(trackingPageId, language) {
  const query = qs.stringify({
    trackingPageId,
    language,
  });
  return fetchRequest(`/tracking/dummy?${query}`);
}

export function getEmbeddedWidget(embeddedWidgetId) {
  return fetchRequest(`/embedded-widgets/${embeddedWidgetId}`);
}

export function getTrackingPageSettings(trackingPageId) {
  return fetchRequest(`/tracking-pages/${trackingPageId}`);
}



// WEBPACK FOOTER //
// ./src/js/actions/api.js